import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
} from "reactstrap";
import TablaFlia from "./TableHover";
import TablaActivity from "./ActivityList";
import { ResponsiveContainer, LineChart, Line } from "recharts";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";


import { toast } from "react-toastify";

import Tabs from "react-responsive-tabs";
import TablaAlumnos from "./AlumnosList";
import PageTitle from "../../../../Layout/AppMain/PageTitle";
import privateActions from "../../../../API/privateCalls/privateActions";
import { MINIJUEGOS, HISTORIAS, PLANETAS, NIVELES, CINTURONES } from "../../Alumnos/component/consts_act";
import TablaDocente from "./docenteList";
export default class Escuelas extends React.Component {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  state = {
    loading: true,
    data: {},
    pageFlia: 0,
    sizeFlia: 7,
    pageAlumnos: 0,
    sizeAlumnos: 10,
    listaDocente: [],
    pageDocente: 0,
    sizeDocente: 10,
    pageActividades: 0,
    sizeActividades: 10,
    listInstituciones: [],
    listaTabs: [],
    selectedAlumno:{},
    selectedInstitucionfromDocente:{},
    selectedTabKey: 0,
    selectedInstitucionfromalumno: {},
    listAlumnos: [],
    selectedActivity: "",
    activityResponse: [],
  };

  componentDidMount() {
    this.loadInstituciones();
  }
  /* 
  Funciona así: Tenes por defecto siempre el Tab de las aulas, haces click en algun aula y se crea un tab nuevo con ese aula que elijiste, 
  Vas a ver todos los alumnos, haces click en algunas de las 5 opciones y se crea un tab mas generico para cualquier de las 5 actividades */

  ////////////////////////////   START  AULAS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadInstituciones() {
    privateActions
      .listInstitucionesAdmin(
  
        this.state.pageFlia,
        this.state.sizeFlia
      )
      .then((res) => {

        this.setState({ listInstituciones: res, loading: false });
      });
  }

  paginateInstituciones(direc) {
    if (direc > 0) {
      this.setState({ pageFlia: this.state.pageFlia + 1 }, () => {
        this.loadInstituciones();
      });
    } else {
      this.setState(
        {
          pageFlia:
            this.state.pageFlia == 0
              ? this.state.pageFlia
              : this.state.pageFlia - 1,
        },
        () => {
          this.loadInstituciones();
        }
      );
    }
  }

  handleAlumno(institucion) {
    this.setState({ selectedInstitucionfromalumno: institucion });
    this.setState({ loading: true });

    privateActions
      .listAlumnosByInstitucion(

        institucion.idPublico,
        this.state.pageAlumnos,
        this.state.sizeAlumnos
      )
      .then((res) => {
        this.setState({
          listAlumnos: res,
          loading: false,
          selectedTabKey: 1,
          listaTabs: [
            {
              title: "Usuarios de: "+ institucion.nombre,
              getContent: () => this.renderAlumnos(),
              index: this.state.listaTabs.length + 1,
            },
          ],
        });
      });
  }
  handleDocente(institucion) {
    this.setState({ selectedInstitucionfromDocente: institucion });
    this.setState({ loading: true });

    privateActions
      .listDocenteByInstitucion(

        institucion.idPublico,
        this.state.pageDocente,
        this.state.sizeDocente
      )
      .then((res) => {
        this.setState({
          listaDocente: res,
          loading: false,
          selectedTabKey: 1,
          listaTabs: [
            {
              title: "Docentes de: "+ institucion.nombre,
              getContent: () => this.renderDocente(),
              index: this.state.listaTabs.length + 1,
            },
          ],
        });
      });
  }
  
  renderInstituciones() {
    if (this.state.loading) return null;
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>Escuelas</CardTitle>
                  <TablaFlia
                    page={this.state.pageFlia}
                    paginate={(num) => this.paginateInstituciones(num)}
                    data={this.state.listInstituciones}
                    onView={(Alumno) => this.handleAlumno(Alumno)}
                    onViewDocente={(Docente) => this.handleDocente(Docente)}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  ////////////////////////////   END  INstituciones     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  ////////////////////////////  START  ALUMNOS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadAlumnos() {
    this.setState({ loading: false });
    privateActions
    .listAlumnosByInstitucion(

      this.state.selectedInstitucionfromalumno.idPublico,
      this.state.pageAlumnos,
      this.state.sizeAlumnos
    )
      .then((res) => {
        this.setState({ listAlumnos: res, loading: false });
        this.setState({ selectedTabKey: 0 }, () => {
          setTimeout(() => {
            this.setState({ selectedTabKey: 1 });
          }, 100);
        });
      });
  }
  renderAlumnos() {
    if (this.state.loading) return null;
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>
                  Usuarios de: {this.state.selectedInstitucionfromalumno.nombre}
                  </CardTitle>
                  <TablaAlumnos
                    openActivity={(e, activity) =>
                      this.openActivity(e, activity)
                    }
                    page={this.state.pageAlumnos}
                    paginate={(num) => this.paginateAlumnos(num)}
                    data={this.state.listAlumnos}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  paginateAlumnos(direc) {
    if (direc > 0) {
      this.setState({ pageAlumnos: this.state.pageAlumnos + 1 }, () => {
        this.loadAlumnos();
      });
    } else {
      this.setState(
        {
          pageAlumnos:
            this.state.pageAlumnos === 0
              ? this.state.pageAlumnos
              : this.state.pageAlumnos - 1,
        },
        () => {
          this.loadAlumnos();
        }
      );
    }
  }

  ////////////////////////////  END  ALUMNOS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


  ////////////////////////////  START  DOCENTES     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadDocentes() {
    this.setState({ loading: false });
    privateActions
      .listDocenteByInstitucion(
        this.state.selectedInstitucionfromDocente.idPublico,
        this.state.pageDocente,
        this.state.sizeDocente
      )
      .then((res) => {
        this.setState({ listaDocente: res, loading: false });
        this.setState({ selectedTabKey: 0 }, () => {
          setTimeout(() => {
            this.setState({ selectedTabKey: 1 });
          }, 100);
        });
      });
  }
  renderDocente() {
    if (this.state.loading) return null;

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>
                    Docentes de: {this.state.selectedInstitucionfromDocente.nombre}
                  </CardTitle>
                  <TablaDocente
                    openActivity={(e, activity) =>
                      this.openActivity(e, activity)
                    }
                    page={this.state.pageDocente}
                    paginate={(num) => this.paginateDocente(num)}
                    data={this.state.listaDocente}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  paginateDocente(direc) {
    if (direc > 0) {
      this.setState({ pageDocente: this.state.pageDocente + 1 }, () => {
        this.loadDocentes();
      });
    } else {
      this.setState(
        {
          pageDocente:
            this.state.pageDocente === 0
              ? this.state.pageDocente
              : this.state.pageDocente - 1,
        },
        () => {
          this.loadDocentes();
        }
      );
    }
  }

  ////////////////////////////  END  DOCENTES     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\




  ////////////////////////////  START  ACTIVITY   \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  //this.state.selectedActivity == LA ACTIVIDAD ACTIVA
  //this.state.activityResponse == LISTA QUE VIENE DEL BACKEND
  //this.state.selectedAlumno == ALUMNO QUE ELEJAN
  renderActivity() {
    if (this.state.loading) return null;

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>{this.state.selectedActivity}</CardTitle>
                  <TablaActivity
                    activity={this.state.selectedActivity}
                    page={this.state.pageActividades}
                    paginate={(num) => this.paginateActivity(num)}
                    data={this.state.activityResponse}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  openActivity = (e, activity) => {
    this.setState({ selectedActivity: activity });
    this.setState({selectedAlumno:e})
    this.setState({ loading: true });

    switch (activity) {
      case CINTURONES:
        privateActions
          .CinturonAsteroideAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case NIVELES:
        privateActions
          .PasoDeNivelAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case PLANETAS:
        privateActions
          .planetasDesbloqueadosAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case HISTORIAS:
        privateActions
          .historiasLeidasAdminAlumnos(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case MINIJUEGOS:
        privateActions
          .MiniJuegosAdminAlumnos(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      default:
        break;
    }
  };


  loadActivity = () => {

    let e = this.state.selectedAlumno
    let activity = this.state.selectedActivity
    switch (activity) {
      case CINTURONES:
        privateActions
          .CinturonAsteroideAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {           
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
            });
            this.setState({ selectedTabKey: 1 }, () => {
              setTimeout(() => {
                this.setState({ selectedTabKey: 2 });
              }, 100);
            });
          });

        break;

      case NIVELES:
        privateActions
          .PasoDeNivelAdminAlumno(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
   
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,

            });
            this.setState({ selectedTabKey: 1 }, () => {
              setTimeout(() => {
                this.setState({ selectedTabKey: 2 });
              }, 100);
            });
          });

        break;

      case PLANETAS:
        privateActions
          .planetasDesbloqueadosAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
       
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,

            });
            this.setState({ selectedTabKey: 1 }, () => {
              setTimeout(() => {
                this.setState({ selectedTabKey: 2 });
              }, 100);
            });
          });

        break;

      case HISTORIAS:
        privateActions
          .historiasLeidasAdminAlumnos(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);

            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,

            });
            this.setState({ selectedTabKey: 1 }, () => {
              setTimeout(() => {
                this.setState({ selectedTabKey: 2 });
              }, 100);
            });
          });

        break;

      case MINIJUEGOS:
        privateActions
          .miniJuegosTiempoPromedio(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
 
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,

            });
            this.setState({ selectedTabKey: 1 }, () => {
              setTimeout(() => {
                this.setState({ selectedTabKey: 2 });
              }, 100);
            });
          });

        break;

      default:
        break;
    }
  };



  paginateActivity(direc) {
    if (direc > 0) {
      this.setState({ pageActividades: this.state.pageActividades + 1 }, () => {
        this.loadActivity()
      });
    } else {
      this.setState(
        {
          pageActividades:
            this.state.pageActividades == 0
              ? this.state.pageActividades
              : this.state.pageActividades - 1,
        },
        () => {
          this.loadActivity()
        }
      );
    }
  }

  ////////////////////////////  END  ACTIVITY   \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  ////////////////////////////  RENDER METHOD \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  handleChangeTab(res) {
    console.warn(res, this.state.selectedTabKey);
    if (res == 0) {
      this.setState({ selectedTabKey: res, listaTabs: [] });
    }
    if (res == 1 && this.state.selectedTabKey == 2) {
      let list = this.state.listaTabs;
      list.pop();
      this.setState({ selectedTabKey: res, listaTabs: list });
    } else {
      this.setState({ selectedTabKey: res });
    }
  }

  render() {
    return (
      <Fragment>
        <PageTitle
          heading={
            this.state.selectedTabKey == 0
              ? `Escuelas `
              : "Detalle"
          }
          subheading={
            this.state.selectedTabKey == 0
              ? "Un espacio dedicado a que puedas ver las escuelas"
              : "Detalle de escuela"
          }
          icon="lnr-graduation-hat icon-gradient bg-mean-fruit"
        />
        <Tabs
          tabsWrapperClass="body-tabs body-tabs-layout"
          transform={false}
          showInkBar={true}
          selectedTabKey={this.state.selectedTabKey}
          onChange={(res) => this.handleChangeTab(res)}
          uid={this.state.pageAlumnos}
          items={[
            {
              title: "Escuelas",
              getContent: () => this.renderInstituciones(),
              index: 0,
            },
            ...this.state.listaTabs,
          ]}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/Escuelas/component/Escuelas.js